import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  createTermsAndConditions,
  getAllTermsAndConditions,
  getTermsAndConditionsByID,
  updateTermsAndConditions,
} from "./services/termsAndCondition.services";
import { clearTermsAndConditionDetails } from "./termsAndConditionSlice";
import { closed } from "../../components/drawer/drawerSlice";
// import FormRichTextField from "../../components/formFields/FormRichTextField";
import FormTextArea from "../../components/formFields/FormTextArea";

const CreateTermsAndCondition: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const TermsAndConditionDetail = useAppSelector(
    (state) => state.termsandcondition.TermsAndConditionDetail
  );
  const TermsAndConditionID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector(
    (state) => state.termsandcondition.formLoading
  );

  useEffect(() => {
    if (TermsAndConditionID) {
      dispatch(getTermsAndConditionsByID(TermsAndConditionID));
    }
  }, [TermsAndConditionID]);

  useEffect(() => {
    return () => {
      dispatch(clearTermsAndConditionDetails());
      dispatch(closed());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      if (!TermsAndConditionID) {
        const insertPayload = {
          TermsAndConditions: values.TermsAndConditions,
          Description: values.Description,
          IsActive: true,
        };
        const response = await dispatch(
          createTermsAndConditions(insertPayload)
        );
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearTermsAndConditionDetails());
          dispatch(getAllTermsAndConditions());
        }
      } else {
        const payload = {
          ID: TermsAndConditionID,
          TermsAndConditions: values.TermsAndConditions,
          Description: values.Description,
          IsActive: values.IsActive,
        };
        const response = await dispatch(updateTermsAndConditions(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearTermsAndConditionDetails());
          dispatch(getAllTermsAndConditions());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={TermsAndConditionDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="TermsAndConditions"
                label="Terms And Conditions"
                component={FormTextField}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Description"
                label="Description"
                component={FormTextArea}
                validator={requiredValidator}
              />
              {/* <Field
                name="Description"
                label="Description"
                component={FormRichTextField}
                validator={requiredValidator}
              /> */}
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginRight: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
              <ButtonWithLoading
                label={TermsAndConditionID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateTermsAndCondition;
